import { Icon, type iconName } from '@/common/components/Icon'
import { cn } from '@/lib/utils'

export function ModalTitle({
  icon,
  title,
  className,
}: {
  icon: iconName
  title: React.ReactNode
  className?: string
}) {
  return (
    <div className={cn('flex items-center gap-[10px]', className)}>
      <div className="flex h-[44px] w-[44px] shrink-0 items-center justify-center rounded-[24px] border border-monochrome-120">
        <Icon
          icon={icon}
          width="18"
          height="18"
          viewBox="0 0 18 18"
          className="text-accent-1 drop-shadow-[0_0_8px_var(--color-accent-1)]"
        />
      </div>
      <span className="text-[18px] font-bold leading-normal text-monochrome-1">
        {title}
      </span>
    </div>
  )
}
